import { render, staticRenderFns } from "./android.vue?vue&type=template&id=19a4afdf&scoped=true"
var script = {}
import style0 from "./android.vue?vue&type=style&index=0&id=19a4afdf&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a4afdf",
  null
  
)

export default component.exports